module.exports = "/wwwroot/img/x-brands.svg?ver=02a391fd";